import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "testimonial-card" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "personal-info" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "job" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "24",
  viewBox: "0 0 30 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "comma"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.67",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M30 6V0C30 0 18 -3.28873e-07 18 12V24H30V12H24C24 12 24 6 30 6V6ZM0 12V24H12V12H6C6 12 6 6 12 6V0C12 0 0 -3.28873e-07 0 12V12Z",
    fill: "#2563EB"
  })
], -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialCard',
  props: {
    name: {},
    job: {},
    text: {},
    img: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: _ctx.img }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.name), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.job), 1)
      ]),
      _hoisted_7
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
  ]))
}
}

})